import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const MeterGlyph = /*#__PURE__*/createElement("g", {
  id: "meter"
}, /*#__PURE__*/createElement("path", {
  d: "M17.5,52.9c-0.8-2.3-1.3-4.8-1.4-7.3c0-0.5,0-0.9,0-1.4c0-0.4,0-0.9,0-1.3l2.5,0.1c0,0.4,0,0.8,0,1.2c0,0.4,0,0.8,0,1.3 c0.1,2.3,0.6,4.5,1.3,6.6L17.5,52.9z M66.5,52.9l-2.4-0.8c0.9-2.5,1.3-5.1,1.3-7.8c0-0.4,0-0.8,0-1.3l0-0.1l2.5-0.1l0,0.1 c0,0.5,0,0.9,0,1.4C68,47.2,67.5,50.1,66.5,52.9z M19.2,38.9l-2.5-0.6c0.8-3.3,2.2-6.4,4.2-9.2l2.1,1.5 C21.1,33.1,19.9,35.9,19.2,38.9z M64.8,38.8c-0.7-3-2-5.8-3.8-8.3L63,29c2,2.8,3.4,5.9,4.2,9.2L64.8,38.8z M25.7,27.4l-1.8-1.8 c2.5-2.4,5.3-4.2,8.5-5.5l0.9,2.4C30.5,23.6,27.9,25.2,25.7,27.4z M58.2,27.3c-2.2-2.1-4.8-3.8-7.7-4.9l0.9-2.4 c3.2,1.2,6.1,3.1,8.5,5.5L58.2,27.3z M37.4,21.2l-0.5-2.5c1.2-0.2,2.5-0.4,3.8-0.5c2.2-0.1,4.3,0,6.4,0.4l-0.5,2.5 c-1.9-0.4-3.8-0.5-5.8-0.4C39.6,20.9,38.5,21,37.4,21.2z"
}), /*#__PURE__*/createElement("path", {
  d: "M45.6,49.2l-2.2-16.7c-0.1-1.1-1.7-1.1-1.9,0l-2.2,16.7c-1.1,0.9-1.7,2.2-1.7,3.7c0,2.7,2.2,4.9,4.9,4.9s4.9-2.2,4.9-4.9 C47.3,51.4,46.6,50.1,45.6,49.2z M42.5,55.6c-1.5,0-2.7-1.2-2.7-2.7s1.2-2.7,2.7-2.7c1.5,0,2.7,1.2,2.7,2.7S44,55.6,42.5,55.6z"
}));
const Meter = createSvg({
  name: 'meter',
  path: MeterGlyph
});

export default Meter;
export { MeterGlyph };
